// extracted by mini-css-extract-plugin
export default {"actionButtons":"adminTable_actionButtons__Dp3Hj","closingBalance":"adminTable_closingBalance__NlaRS","alignRight":"adminTable_alignRight__svvI2"};